module.exports = "/_next/static/images/icon-favorite-star-bf32f45e7a2ab1aa45cedcdd9f3642b3.svg";